import './AboutPageElementCss/ExpertProfileModal.css';
import logo from '../../Assets/logo.png';
import { RxCross2 } from "react-icons/rx";

export default function ExpertProfileModal({ isOpen, onClose, expert }) {
    if (!isOpen || !expert) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-box" onClick={(e) => e.stopPropagation()}>
                <div className="expert-modal-header-row">
                    <div className="expert-modal-image">
                        <img src={expert.ManImage} alt="Expert" />
                    </div>
                    <div className="expert-modal-info">
                        <img src={logo} alt="RB Diagnostics Logo" className="rb-logo" />

                        {/* ManName contains HTML */}
                        <div
                            className="expert-name"
                            dangerouslySetInnerHTML={{ __html: expert.ManName }}
                        />
                        <p className="expert-role">{expert.ManRole}</p>
                    </div>
                </div>

                <div
                    className="expert-modal-description"
                    dangerouslySetInnerHTML={{ __html: expert.ManDesc }}
                />

                <button onClick={onClose} className="close-btn">X</button>
            </div>
        </div>
    );
}
